import { CecotecLogo } from "./logo-cecotec";

export const Svg = { CecotecLogo };
